export enum DISPLAY_BOARD_TYPES {
  WORKFLOW = 1,
  FAMILY,
  PATIENT,
  ASSETS_PAR_LEVEL,
}
